<template>
  <div>
    <el-badge :hidden="!qty" :value="qty">
      <van-image :src="src" lazy-load width="100%" :radius="gImgRound()"></van-image>
    </el-badge>

    <!-- {{ gImgRound() }} -->
  </div>
</template>

<style scoped>
.van-image {
  border-radius: 3rem;
  margin: 0.1rem;
}
</style>

<script>
export default {
  components: {},
  props: {
    src: String,
    qty: Number,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
